import React, { PureComponent } from "react";
import IconButton from "@material-ui/core/IconButton";
import SettingsIcon from "@material-ui/icons/Settings";
import MoveHandleIcon from "@material-ui/icons/OpenWith";
import FormText from "../../components/form/FormText";
import _ from "lodash";
import FormTextArea from "../../components/form/FormTextArea";
import SectionHeader from "../../components/SectionHeader";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { getGlobalClasses } from "../../themes";

import Popover from "@material-ui/core/Popover";
import Button from "@material-ui/core/Button";
import FormCheckbox from "../../components/form/FormCheckbox";
import FormDatePicker from "../../components/form/FormDatePicker";
import FormTimePicker from "../../components/form/FormTimePicker";
import UserPicker from "../../components/advancedForm/UserPicker";
import FleetPicker from "../../components/advancedForm/FleetPicker";
import FormFileUploader from "../../components/form/FormFileUploader";
import FleetDepartmentPicker from "../../components/advancedForm/FleetDepartmentPicker";
import FormSelect from "../../components/form/FormSelect";

const styles = (theme) => {
  return {
    ...getGlobalClasses(theme),
    button: {
      margin: 8,
    },
    itemContainer: {
      position: "relative",
      display: "flex",
    },
    insidePopover: {
      padding: "10px 20px 20px 20px",
    },
    overlay: {
      position: "absolute",
      zIndex: 99,
      left: 0,
      top: 0,
      right: 0,
      bottom: 0,
      border: "1px solid transparent",
      transition: "0.5s",
      opacity: 0,
      backgroundColor: `rgba(6, 126, 253, .2)`,
      borderRadius: 4,
      /*
			'&:hover': {
				border: '1px solid blue',
				opacity : .5,
			},
			*/
    },
    moveIcon: {
      width: 24,
      height: 24,
      display: "inline-flex",

      flex: "0 0 auto",
      color: "rgba(0, 0, 0, 0.54)",
      padding: 12,
      overflow: "visible",
      fontSize: "1.5rem",
      textAlign: "center",
      transition: "background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
      borderRadius: "50%",
      margin: 8,
      alignItems: "center",
      verticalAlign: "middle",
      justifyContent: "center",
      "&:hover": {
        backgroundColor: `rgba(18, 137, 212, 0.08)`,
      },
    },
    settingWrapper: {
      width: "100%",
      display: "inline-flex",
      margin: "3px 0px",
    },
  };
};

class Card extends PureComponent {
  constructor(props) {
    super(props);

    const isRequired = true;

    let settings = [
      { path: "label", label: "Field label", type: "text", isRequired },
      { path: "helpText", label: "Help text", type: "text" },
      { path: "path", label: "Storage ID", type: "text", isRequired },
      { path: "isRequired", label: "Required", type: "checkbox" },
      {
        path: "includeInDetails",
        label: "Include in details",
        type: "checkbox",
      },
      { path: "isHalfWidth", label: "Half Width", type: "checkbox" },
    ];

    const type = _.get(props, "item.type");

    if (type === "tmwOrderId") {
      settings = [
        {
          path: "label",
          label: "Field Label",
          type: "text",
          value: "TMW Order ID",
          isRequired,
        },
        { path: "helpText", label: "Help text", type: "text" },
        {
          path: "path",
          label: "Storage ID",
          type: "text",
          value: "tmwOrderId",
          isRequired,
        },
        { path: "isRequired", label: "Required", type: "checkbox" },
        {
          path: "includeInDetails",
          label: "Include in details",
          type: "checkbox",
        },
        { path: "isHalfWidth", label: "Half Width", type: "checkbox" },
        {
          path: "doNotFillAssignedToDriverUserId",
          label: "Do not auto fill driver",
          type: "checkbox",
        },
      ];
    } else if (type === "sectionHeader") {
      settings = [
        { path: "label", label: "Header Text", type: "text", isRequired },
      ];
    } else if (type === "userPicker") {
      settings = [
        { path: "label", label: "Field Label", type: "text", isRequired },
        { path: "helpText", label: "Help text", type: "text" },
        { path: "path", label: "Storage ID", type: "text", isRequired },
        {
          path: "whoToShow",
          label: "Who to show",
          type: "select",
          value: "all",
          options: [
            { value: "all", display: "All Employees" },
            { value: "driversOnly", display: "Drivers Only" },
            {
              value: "nonDriversOnly",
              display: "Non-drivers Only (no email groups)",
            },
            {
              value: "nonDriversOnlyWithEmailGroups",
              display: "Non-drivers Only (with email groups)",
            },
          ],
        },
        { path: "selectMultiple", label: "Select multiple", type: "checkbox" },
        { path: "isRequired", label: "Required", type: "checkbox" },
        {
          path: "includeInDetails",
          label: "Include in details",
          type: "checkbox",
        },
        { path: "isHalfWidth", label: "Half Width", type: "checkbox" },
      ];
    }

    const { item } = this.props;

    //- Might be an update and start the cards off with values
    settings.forEach((setting) => {
      const { path } = setting;
      if (!_.isNil(item[path])) {
        setting.value = item[path];
      }
    });

    this.state = {
      anchorEl: null,
      settings,
    };
  }

  handlePopup = (event) => {
    this.setState({
      anchorEl: event.currentTarget,
    });
  };

  handleClose = () => {
    this.setState({
      anchorEl: null,
    });
  };

  handleRemove = () => {
    this.props.remove();
  };

  //- Path is always a string
  //- value is never an event (value.target)
  onChange = (value, path) => {
    const arrayPath = _.toPath(path);
    const basePath = _.head(arrayPath);
    let base = this.state[basePath];
    let newState = {};

    if (_.isArray(base) || _.isObject(base)) {
      base = _.cloneDeep(base);
      _.set(base, arrayPath.slice(1), value);
      newState[basePath] = base;
    } else {
      newState[basePath] = value;
    }

    //- Clear any errors on the path
    let formFieldError = Object.assign({}, this.state.formFieldError);
    delete formFieldError[path];
    newState.formFieldError = formFieldError;
    this.setState(newState);
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.state.settings !== prevState.settings) {
      this.props.onSettingsChange(this.state.settings);
    }
  }

  getInputProps = (path, defaultValue) => {
    return {
      key: path,
      path,
      value: this.getValue(path, defaultValue),
      checked: this.getValue(path, defaultValue),
      error: this.getError(path),
      onChange: this.onChange,
    };
  };

  getValue = (path, defaultValue) => {
    const _d = _.isUndefined(defaultValue) ? "" : defaultValue;
    return _.get(this.state, path, _d);
  };

  getError = (path) => {
    return _.get(this.state.formFieldError, path);
  };

  render() {
    const { item, classes } = this.props;
    const { settings } = this.state;
    const { type } = item;

    let inside;
    if (type === "text") {
      inside = this.renderText();
    } else if (type === "textArea") {
      inside = this.renderTextArea();
    } else if (type === "checkbox") {
      inside = this.renderCheckbox();
    } else if (type === "tmwOrderId") {
      inside = this.renderTmwOrderId();
    } else if (type === "datePicker") {
      inside = this.renderDatePicker();
    } else if (type === "timePicker") {
      inside = this.renderTimePicker();
    } else if (type === "userPicker") {
      inside = this.renderUserPicker();
    } else if (type === "fleetDepartmentPicker") {
      inside = this.renderFleetDepartmentPicker();
    } else if (type === "fleetPicker") {
      inside = this.renderFleetPicker();
    } else if (type === "sectionHeader") {
      inside = this.renderSectionHeader();
    } else if (type === "fileUploader") {
      inside = this.renderFileUploader();
    } else {
      inside = <div>huh</div>;
    }

    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);

    return (
      <div>
        <div className={classes.itemContainer}>
          <div style={{ position: "relative", flexGrow: 1 }}>
            <div className={classes.overlay} />
            {inside}
          </div>
          <div>
            <div {...this.props.dragHandleProps} className={classes.moveIcon}>
              <MoveHandleIcon />
            </div>
            <IconButton
              className={classes.button}
              aria-label="Delete"
              color={"primary"}
              onClick={this.handlePopup}
            >
              <SettingsIcon />
            </IconButton>
          </div>
        </div>
        <Popover
          id="simple-popper"
          open={open}
          anchorEl={anchorEl}
          onClose={this.handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          <div className={classes.insidePopover}>
            {settings.map((setting, index) => {
              const { path, label, helpText, type, options } = setting;

              if (type === "text") {
                return (
                  <div className={classes.settingWrapper} key={path}>
                    <FormText
                      {...this.getInputProps(`settings.${index}.value`)}
                      label={label}
                      helpText={helpText}
                    />
                  </div>
                );
              } else if (type === "checkbox") {
                return (
                  <div key={path} style={{ padding: "10px 0px 10px 10px" }}>
                    <FormCheckbox
                      {...this.getInputProps(`settings.${index}.value`, false)}
                      label={label}
                    />
                  </div>
                );
              } else if (type === "select") {
                return (
                  <div className={classes.settingWrapper} key={path}>
                    <FormSelect
                      {...this.getInputProps(`settings.${index}.value`)}
                      label={label}
                      helpText={helpText}
                      options={options}
                    />
                  </div>
                );
              } else {
                return <div>Missing type : {type}</div>;
              }
            })}

            <div>
              <Button
                variant="contained"
                color="primary"
                className={classes.button}
                onClick={this.handleClose}
              >
                Done
              </Button>
              <Button
                variant="contained"
                className={classes.button}
                onClick={this.handleRemove}
              >
                Remove
              </Button>
            </div>
          </div>
        </Popover>
      </div>
    );
  }

  renderText = () => {
    const { settings } = this.state;
    const settingByPath = _.keyBy(settings, "path");
    return (
      <FormText
        label={settingByPath.label.value || "Text Field label"}
        value=""
        path={""}
        required={settingByPath.isRequired.value || false}
        helpText={settingByPath.helpText.value || "help text"}
        onChange={_.noop}
      />
    );
  };

  renderTextArea = () => {
    const { settings } = this.state;
    const settingByPath = _.keyBy(settings, "path");
    return (
      <FormTextArea
        label={settingByPath.label.value || "Text Area Field label"}
        rows={4}
        value=""
        path={""}
        required={settingByPath.isRequired.value || false}
        helpText={settingByPath.helpText.value || "help text"}
        onChange={_.noop}
      />
    );
  };

  renderCheckbox = () => {
    const { settings } = this.state;
    const settingByPath = _.keyBy(settings, "path");
    return (
      <FormCheckbox
        label={settingByPath.label.value || "Checkbox label"}
        value=""
        path={""}
        checked={false}
        required={settingByPath.isRequired.value || false}
        helpText={settingByPath.helpText.value || "help text"}
        onChange={_.noop}
      />
    );
  };

  renderTmwOrderId = () => {
    const { settings } = this.state;
    const settingByPath = _.keyBy(settings, "path");
    return (
      <FormText
        label={settingByPath.label.value || "TMW Order ID Field Label"}
        value=""
        path={""}
        required={settingByPath.isRequired.value || false}
        helpText={settingByPath.helpText.value || "help text"}
        onChange={_.noop}
      />
    );
  };

  renderDatePicker = () => {
    const { settings } = this.state;
    const settingByPath = _.keyBy(settings, "path");
    return (
      <FormDatePicker
        label={settingByPath.label.value || "Date Field Label"}
        value=""
        path={""}
        required={settingByPath.isRequired.value || false}
        helpText={settingByPath.helpText.value || "help text"}
        onChange={_.noop}
      />
    );
  };

  renderTimePicker = () => {
    const { settings } = this.state;
    const settingByPath = _.keyBy(settings, "path");
    return (
      <FormTimePicker
        label={settingByPath.label.value || "Time Field Label"}
        value=""
        path={""}
        required={settingByPath.isRequired.value || false}
        helpText={settingByPath.helpText.value || "help text"}
        onChange={_.noop}
      />
    );
  };

  renderUserPicker = () => {
    const { settings } = this.state;
    const settingByPath = _.keyBy(settings, "path");
    return (
      <UserPicker
        label={settingByPath.label.value || "User Picker Field Label"}
        value={null}
        path={""}
        required={settingByPath.isRequired.value || false}
        helpText={settingByPath.helpText.value || "help text"}
        onChange={_.noop}
      />
    );
  };

  renderFleetDepartmentPicker = () => {
    const { settings } = this.state;
    const settingByPath = _.keyBy(settings, "path");
    return (
      <FleetDepartmentPicker
        label={
          settingByPath.label.value || "Fleet / Department Picker Field Label"
        }
        value={""}
        path={""}
        required={settingByPath.isRequired.value || false}
        helpText={settingByPath.helpText.value || "help text"}
        onChange={_.noop}
      />
    );
  };
  renderFleetPicker = () => {
    const { settings } = this.state;
    const settingByPath = _.keyBy(settings, "path");
    return (
      <FleetPicker
        label={settingByPath.label.value || "Fleet Picker Field Label"}
        value={""}
        path={""}
        required={settingByPath.isRequired.value || false}
        helpText={settingByPath.helpText.value || "help text"}
        onChange={_.noop}
      />
    );
  };

  renderFileUploader = () => {
    const { settings } = this.state;
    const settingByPath = _.keyBy(settings, "path");
    return (
      <FormFileUploader
        label={settingByPath.label.value || "File Uploader Field Label"}
        value={""}
        path={""}
        required={settingByPath.isRequired.value || false}
        helpText={settingByPath.helpText.value || "help text"}
        onChange={_.noop}
      />
    );
  };

  renderSectionHeader = () => {
    const { settings } = this.state;
    const settingByPath = _.keyBy(settings, "path");
    return (
      <SectionHeader
        label={settingByPath.label.value || "Section Header Text"}
      />
    );
  };
}

Card.propTypes = {
  classes: PropTypes.object,
  onSettingsChange: PropTypes.func,
  item: PropTypes.object.isRequired,
};

export default _.flow([withStyles(styles)])(Card);
